<template>
  <div>
    <ed-table
    :key="$root.$session.versao"
      :headers="arrayHeaders"
      :rows="arrayRows"
      :pagination="objPagination"
      :filter="formFiltros"
      :loading="loading"
      disabledRegisterRows
      disabledEditRows
      disabledDeleteRows
      @search="getExtrato"
      @filter="getExtrato"
    >
      <template slot="table-filter">
        <ed-input-date
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          label="Data Competência"
          name="arrayData"
          v-model="formFiltros.arrayDataCadastro"
          multiple
          clearable
        />

        <ed-input-select
          class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4"
          label="Status"
          name="arrayStatus"
          v-model="formFiltros.arrayStatus"
          :items="[
          {intId:'PAGO',strNome:'PAGO'},
          {intId:'CANCELADO',strNome:'CANCELADO'},
          {intId:'EMABERTO',strNome:'EM ABERTO'},
          ]"
          multiple
          clearable
        />
      </template>
    </ed-table>
  </div>
</template>

<script>
import { EdTable, EdInputDate,EdInputSelect} from "@/components/common/form";

export default {
  name: "pageCadastroEmpresa",
  props: {},
  components: {
    EdTable,
    EdInputDate,
    EdInputSelect,
  },
  props: {
    formData: {
      type: [Object],
      required: false,
      default: null,
    },
  },
  watch: {},
  mounted() {
    this.getExtrato();
  },
  beforeDestroy() {
    this.arrayHeaders = [];
    this.arrayRows = [];
    this.objPagination = null;
  },
  created() {},
  data() {
    return {
      loading: false,
      boolCarregado: false,
      arrayHeaders: [
        {
          text: "Data",
          sortable: true,
          value: "strData",
        },
        {
          text: "Vencimento",
          sortable: true,
          value: "data_vencimento",
        },
        {
          text: "Valor",
          sortable: true,
          value: "floatValor",
        },
        {
          text: "Código do Boleto",
          sortable: true,
          value: "nossoNumero",
        },
        {
          text: "Código Interno",
          sortable: true,
          value: "numeroBoleto",
        },
        {
          text: "Pagador",
          sortable: true,
          value: "strPagador",
        },
        {
          text: "Status",
          sortable: true,
          value: "strStatus",
        },
      ],
      arrayRows: [],
      objPagination: null,
      formFiltros: {
        boolListarBoleto: true,
        intContaBancariaId: this.formData.intId,
        arrayStatus:[],
        arrayDataCadastro: [
          this.$utilidade.addDate(-7, null, "D", "DD/MM/YYYY"),
          this.$utilidade.addDate(1, null, "D", "DD/MM/YYYY"),
        ],
      },
    };
  },
  methods: {
    getExtrato() {

      this.loading = true;
      this.arrayRows = []

      this.$root.$request
        .get("Configuracoes/CanalIntegracao", this.formFiltros)
        .then((objResult) => {
          this.loading = false;
          let arrayRows = [];

          if (objResult.status == 200 && objResult.result) {
            objResult.result.forEach((objModel) => {
              let strCor = "";

              let item = {
                strData:
                  '<span style="color:' +
                  strCor +
                  '">' +
                  this.$utilidade.toDate(objModel.data_processamento, true) +
                  "</span>",
                data_vencimento:
                  '<span style="color:' +
                  strCor +
                  '">' +
                  this.$utilidade.toDate(objModel.data_vencimento, true) +
                  "</span>",
                nossoNumero:objModel.nossoNumero+'<br>'+objModel.codigo_barra,
                numeroBoleto:objModel.numeroBoleto,
                strPagador:objModel.pagador.strNumeroDocumento+' - '+objModel.pagador.strNome,
                strStatus:objModel.status,
                floatValor:
                  '<span style="color:' +
                  strCor +
                  '">R$ ' +
                  this.$utilidade.floatToMoney(objModel.valor) +
                  "</span>",
                _item: objModel,
              };

              arrayRows.push(item);
            });

            this.arrayRows = arrayRows;
          }
        });
    },
  },
};
</script>
